import DependenciesLoader from '../../../model/loader/user-base-entities-loader'
import ResourceGetter     from '../../../model/resource/getter/resource-getter'
import User               from '../../../model/resource/User'
import PDELinkGenerator   from '../../../model/wrapper/pde-link-params'
import DefinitionGetter
                          from '../../../model/resource/getter/definitions-getter'

export default {
  name: 'HeaderNotifications',

  data () {
    return {
      notifications:      [],
      notificationsCount: 0,
      title:              '',
      refreshTimeout:     10000,

      resource:   null,
      definition: null
    }
  },

  created () {
    this._initNotificationCount()
    this._initAutoRefresh()
  },

  methods: {

    /**
     *
     * @private
     */
    _initNotificationCount () {
      User
        .getUserParams((userData) => {
          this.notificationsCount = userData.tNotificationCount
        }, (error) => {this.handleApiError(error)}, true)
    },

    /**
     *
     * @return {*}
     * @private
     */
    _initDefinition () {
      return DependenciesLoader
        .getNotificationsData((response) => {
          if (!response.data[0].Fields) {
            return
          }
          response        = response.data[0].Fields[0]
          this.definition = response
          this.resource   = ResourceGetter.get(response.ViewName)
        }, (error) => {
          this.handleApiError(error)
        })
    },

    /**
     *
     * @param notification
     * @param success
     * @return {*}
     * @private
     */
    _initFormDefinition (notification, success) {
      let args = {
        code:                   notification.STIDTENTITY,
        idtEntityStructureFrom: notification.IDTENTITY
      }

      return DefinitionGetter
        .getDataDefinition(
          args, success, (error) => {this.handleApiError(error) })
    },

    /**
     *
     * @private
     */
    _initData () {
      if (!this.definition) {
        return
      }

      let args = {
        whereCondition: this.definition.WhereCondition,
        idtEntity:      this.definition.idtEntityStructureFrom,
        orderBy:        this.definition.OrderBy
      }

      this
        .resource
        .find(args)
        .then(response => {
          this.notifications = response.data
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },

    /**
     *
     * @private
     */
    _initAutoRefresh () {
      this.$store.commit('setHeaderNotificationTimer', setInterval(() => {
        this._initNotificationCount()
      }, this.refreshTimeout))

    },

    /**
     *
     * @private
     */
    _open () {
      if (this.definition) {
        if (this.notificationsCount !== this.notifications.length) {
          this._initData()
        }

        return
      }

      Promise
        .all([this._initDefinition()])
        .then(() => {
          this._initData()
        })
    },

    /**
     *
     * @param notification
     * @param event
     * @private
     */
    _click (notification, event) {
      event.preventDefault()

      if (!notification.IDTENTITY) {
        return
      }

      this.$refs.holder.classList.remove('show')
      this.$refs.menu.classList.remove('show')

      this._callActionRead(notification, () => {
        this._initNotificationCount()
        this._initData()
      })
      this._callEditorPage(notification)
    },

    /**
     *
     * @param notification
     * @param event
     * @private
     */
    _read (notification, event) {
      event.preventDefault()

      let successRead = (response) => {
        this._remove(notification)
      }

      this._callActionRead(notification, successRead)
    },

    /**
     *
     * @param notification
     * @param successCallback
     * @private
     */
    _callActionRead (notification, successCallback) {
      let args = {
        ruleType: 'Action',
        ruleName: 'spNotification_Action_Read',
        where:    '',
        value:    notification
      }

      this
        .resource
        .callBusinessRule(args)
        .then((response) => {
          if (successCallback) {
            successCallback(response)
          }
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },

    /**
     *
     * @param notification
     * @private
     */
    _callEditorPage (notification) {
      let success = (def) => {

        let getDataArgs = {
              whereCondition: notification.WHERECONDITION,
              idtEntity:      notification.IDTENTITY
            },
            resource    = ResourceGetter.get(def.viewName)

        resource
          .find(getDataArgs)
          .then((dataResponse) => {
            PDELinkGenerator.defaults = dataResponse.data[0]
            PDELinkGenerator.redir    = 'grid'

            this.$router.push(PDELinkGenerator.getParams(def))
          })
      }

      this._initFormDefinition(notification, success)
    },

    /**
     *
     * @param notification
     * @private
     */
    _remove (notification) {
      for (let i = 0; i < this.notifications.length; i++) {
        let item = this.notifications[i]
        if (item.ID === notification.ID) {
          this._initNotificationCount()
          this._initData()
        }
      }
    }
  }

}
